export default __webpack_public_path__ + "static/media/ceramol-iage-daytime-treatment-uv.3ffe7753.png";